import {
    corePropertyFeatures,
    extraPropertFeatures
} from '../common';

const validateAttribute = ( name, value ) => {
    let result = {
        error: null
    };

    const features = [].concat( corePropertyFeatures, extraPropertFeatures );

    const feature = features.find( feature => feature.mapping === name );

    if ( !feature ) {
        result.error = new Error( `unknown feature "${name}"` );
        return result;
    }

    if ( !( 'validate' in feature ) ) {
        return result;
    }

    const valid = feature.validate( value );

    if ( valid.error !== null ) {
        result.error = valid.error;
        return result;
    }

    return result;
};

export {
    validateAttribute
};



// WEBPACK FOOTER //
// ./src/components/property-qc/validation/attribute.js